import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';

const PrivateRoute = ({ user, component: Component, ...other }) => (
  <Route
    {...other}
    render={props =>
      user ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/signin',
            state: { referrer: props.location.pathname },
          }}
        />
      )
    }
  />
);

const mapStateToProps = ({ oidc: { user } }) => ({
  user,
});

export default connect(mapStateToProps)(PrivateRoute);
